import { CircleMarker, Polygon, useMapEvents } from "react-leaflet";
import type { LatLng } from "leaflet";

const DRAWING_STYLE = { color: "#e0913f", weight: 2, fillOpacity: 0.12, dashArray: "5,4" };

/**
 * Links map clicks to drawing mode — no state of its own (lives in
 * SubBasinMap.tsx, which is also what paints the toolbar outside the
 * `MapContainer`): react-leaflet requires `useMapEvents` to be called
 * inside the `MapContainer` itself, hence this separate component. Same
 * pattern as `RectangleSelectionLayer` (RectangleSelection.tsx).
 */
export function DrawEvents({ onMapClick }: { onMapClick: (latlng: LatLng) => void }) {
  useMapEvents({
    click(e) {
      onMapClick(e.latlng);
    },
  });
  return null;
}

/** Live preview of the polygon being drawn (vertices placed so far + the outline they form). */
export function VistaPreviaDibujo({ vertices }: { vertices: LatLng[] }) {
  if (vertices.length === 0) return null;
  return (
    <>
      {vertices.length > 1 && <Polygon positions={vertices} pathOptions={DRAWING_STYLE} />}
      {vertices.map((v, i) => (
        <CircleMarker
          key={i}
          center={v}
          radius={4}
          pathOptions={{ color: "#e0913f", fillColor: "#e0913f", fillOpacity: 1 }}
        />
      ))}
    </>
  );
}
